export { default } from "./SpeedDialIcon.js";
export { default as speedDialIconClasses } from "./speedDialIconClasses.js";
export * from "./speedDialIconClasses.js";